<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before: always;"></div>
<p class="P_Normal__And__Page_Break" id="auto_bookmark_toc_3">To my family, with all my wishes for a merry Christmas. </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?9be08158